[
  {
    "id": "0",
    "type": "sword",
    "name": "Rusty Sword",
    "image": "images/weapons/swords/Rusty Sword.png",
    "damageMin": 2,
    "damageMax": 5,
    "speed": 0,
    "critChance": 0.02,
    "critPower": 0,
    "defense": 0,
    "knockback": 0,
    "level": 1,
    "obtain": "Given at The Mines entrance.",
    "sellPrice": 50,
    "canEnchant": false
  },
  {
    "id": "12",
    "type": "sword",
    "name": "Wooden Blade",
    "image": "images/weapons/swords/Wooden Blade.png",
    "damageMin": 3,
    "damageMax": 7,
    "speed": 0,
    "critChance": 0.02,
    "critPower": 0,
    "defense": 0,
    "knockback": 0,
    "level": 1,
    "obtain": "The Mines floor 10 chest, or purchased from the Adventurer's Guild.",
    "sellPrice": 50,
    "canEnchant": true
  },
  {
    "id": "11",
    "type": "sword",
    "name": "Steel Smallsword",
    "image": "images/weapons/swords/Steel Smallsword.png",
    "damageMin": 4,
    "damageMax": 8,
    "speed": 2,
    "critChance": 0.02,
    "critPower": 0,
    "defense": 0,
    "knockback": 0,
    "level": 1,
    "obtain": "The Mines floor 20 chest, or purchased from the Adventurer's Guild for 750g.",
    "sellPrice": 50,
    "canEnchant": true
  },
  {
    "id": "43",
    "type": "sword",
    "name": "Pirate's Sword",
    "image": "images/weapons/swords/Pirate's Sword.png",
    "damageMin": 8,
    "damageMax": 14,
    "speed": 2,
    "critChance": 0.02,
    "critPower": 0,
    "defense": 0,
    "knockback": 0,
    "level": 2,
    "obtain": "The Mines floor 50 chest, or purchased from the Adventurer's Guild for 850g.",
    "sellPrice": 100,
    "canEnchant": true
  },
  {
    "id": "1",
    "type": "sword",
    "name": "Silver Saber",
    "image": "images/weapons/swords/Silver Saber.png",
    "damageMin": 8,
    "damageMax": 15,
    "speed": 0,
    "critChance": 0.02,
    "critPower": 0,
    "defense": 1,
    "knockback": 0,
    "level": 2,
    "obtain": "The Mines, or purchased from the Adventurer's Guild.",
    "sellPrice": 100,
    "canEnchant": true
  },
  {
    "id": "44",
    "type": "sword",
    "name": "Cutlass",
    "image": "images/weapons/swords/Cutlass.png",
    "damageMin": 9,
    "damageMax": 17,
    "speed": 2,
    "critChance": 0.02,
    "critPower": 0,
    "defense": 0,
    "knockback": 0,
    "level": 3,
    "obtain": "The Mines, or purchased from the Adventurer's Guild.",
    "sellPrice": 150,
    "canEnchant": true
  },
  {
    "id": "15",
    "type": "sword",
    "name": "Forest Sword",
    "image": "images/weapons/swords/Forest Sword.png",
    "damageMin": 8,
    "damageMax": 18,
    "speed": 2,
    "critChance": 0.02,
    "critPower": 0,
    "defense": 1,
    "knockback": 0,
    "level": 3,
    "obtain": "The Mines floors 20–60.",
    "sellPrice": 150,
    "canEnchant": true
  },
  {
    "id": "6",
    "type": "sword",
    "name": "Iron Edge",
    "image": "images/weapons/swords/Iron Edge.png",
    "damageMin": 12,
    "damageMax": 25,
    "speed": -2,
    "critChance": 0.02,
    "critPower": 0,
    "defense": 1,
    "knockback": 3,
    "level": 3,
    "obtain": "The Mines floors 41–59.",
    "sellPrice": 150,
    "canEnchant": true
  },
  {
    "id": "65",
    "type": "sword",
    "name": "Meowmere",
    "image": "images/weapons/swords/Meowmere.png",
    "damageMin": 20,
    "damageMax": 20,
    "speed": 4,
    "critChance": 0.02,
    "critPower": 0,
    "defense": 0,
    "knockback": 2,
    "level": 4,
    "obtain": "Wizard's Tower basement.",
    "sellPrice": 200,
    "canEnchant": true
  },
  {
    "id": "5",
    "type": "sword",
    "name": "Bone Sword",
    "image": "images/weapons/swords/Bone Sword.png",
    "damageMin": 20,
    "damageMax": 30,
    "speed": 4,
    "critChance": 0.02,
    "critPower": 0,
    "defense": 0,
    "knockback": 2,
    "level": 5,
    "obtain": "The Mines floors 75+, or dropped by Skeletons.",
    "sellPrice": 250,
    "canEnchant": true
  },
  {
    "id": "10",
    "type": "sword",
    "name": "Claymore",
    "image": "images/weapons/swords/Claymore.png",
    "damageMin": 20,
    "damageMax": 32,
    "speed": -4,
    "critChance": 0.02,
    "critPower": 0,
    "defense": 2,
    "knockback": 3,
    "level": 5,
    "obtain": "The Mines, or purchased from the Adventurer's Guild.",
    "sellPrice": 250,
    "canEnchant": true
  },
  {
    "id": "14",
    "type": "sword",
    "name": "Neptune's Glaive",
    "image": "images/weapons/swords/Neptune's Glaive.png",
    "damageMin": 18,
    "damageMax": 35,
    "speed": -1,
    "critChance": 0.02,
    "critPower": 0,
    "defense": 2,
    "knockback": 4,
    "level": 5,
    "obtain": "Fishing Treasure Chests.",
    "sellPrice": 250,
    "canEnchant": true
  },
  {
    "id": "7",
    "type": "sword",
    "name": "Templar's Blade",
    "image": "images/weapons/swords/Templar's Blade.png",
    "damageMin": 22,
    "damageMax": 29,
    "speed": 0,
    "critChance": 0,
    "critPower": 0,
    "defense": 1,
    "knockback": 0,
    "level": 5,
    "obtain": "The Mines, or purchased from the Adventurer's Guild.",
    "sellPrice": 250,
    "canEnchant": true
  },
  {
    "id": "13",
    "type": "sword",
    "name": "Insect Head",
    "image": "images/weapons/swords/Insect Head.png",
    "damageMin": 20,
    "damageMax": 30,
    "speed": 2,
    "critChance": 0.04,
    "critPower": 0,
    "defense": 0,
    "knockback": 0,
    "level": 6,
    "obtain": "Adventurer's Guild reward for killing 80 bug-type monsters.",
    "sellPrice": 200,
    "canEnchant": true
  },
  {
    "id": "8",
    "type": "sword",
    "name": "Obsidian Edge",
    "image": "images/weapons/swords/Obsidian Edge.png",
    "damageMin": 30,
    "damageMax": 45,
    "speed": -1,
    "critChance": 0.02,
    "critPower": 10,
    "defense": 0,
    "knockback": 0,
    "level": 6,
    "obtain": "The Mines floor 90 chest.",
    "sellPrice": 300,
    "canEnchant": true
  },
  {
    "id": "60",
    "type": "sword",
    "name": "Ossified Blade",
    "image": "images/weapons/swords/Ossified Blade.png",
    "damageMin": 26,
    "damageMax": 42,
    "speed": -2,
    "critChance": 0.02,
    "critPower": 0,
    "defense": 1,
    "knockback": 2,
    "level": 6,
    "obtain": "The Mines floor 90, or from a Mystery Box.",
    "sellPrice": 300,
    "canEnchant": true
  },
  {
    "id": "42",
    "type": "sword",
    "name": "Haley's Iron",
    "image": "images/weapons/swords/Haley's Iron.png",
    "damageMin": 30,
    "damageMax": 45,
    "speed": -1,
    "critChance": 0.02,
    "critPower": 10,
    "defense": 0,
    "knockback": 0,
    "level": 6,
    "obtain": "Haley's stall at the Desert Festival.",
    "sellPrice": 300,
    "canEnchant": true
  },
  {
    "id": "39",
    "type": "sword",
    "name": "Leah's Whittler",
    "image": "images/weapons/swords/Leah's Whittler.png",
    "damageMin": 30,
    "damageMax": 45,
    "speed": -1,
    "critChance": 0.02,
    "critPower": 10,
    "defense": 0,
    "knockback": 0,
    "level": 6,
    "obtain": "Leah's stall at the Desert Festival.",
    "sellPrice": 300,
    "canEnchant": true
  },
  {
    "id": "3",
    "type": "sword",
    "name": "Holy Blade",
    "image": "images/weapons/swords/Holy Blade.png",
    "damageMin": 20,
    "damageMax": 27,
    "speed": 4,
    "critChance": 0.02,
    "critPower": 0,
    "defense": 2,
    "knockback": 0,
    "level": 7,
    "obtain": "The Mines after floor 80.",
    "sellPrice": 350,
    "canEnchant": true
  },
  {
    "id": "52",
    "type": "sword",
    "name": "Tempered Broadsword",
    "image": "images/weapons/swords/Tempered Broadsword.png",
    "damageMin": 29,
    "damageMax": 44,
    "speed": -3,
    "critChance": 0.02,
    "critPower": 0,
    "defense": 3,
    "knockback": 3,
    "level": 7,
    "obtain": "The Mines, or Skull Cavern.",
    "sellPrice": 350,
    "canEnchant": true
  },
  {
    "id": "48",
    "type": "sword",
    "name": "Yeti Tooth",
    "image": "images/weapons/swords/Yeti Tooth.png",
    "damageMin": 26,
    "damageMax": 42,
    "speed": 0,
    "critChance": 0.02,
    "critPower": 10,
    "defense": 4,
    "knockback": 0,
    "level": 7,
    "obtain": "The Mines floors 81–99.",
    "sellPrice": 350,
    "canEnchant": true
  },
  {
    "id": "50",
    "type": "sword",
    "name": "Steel Falchion",
    "image": "images/weapons/swords/Steel Falchion.png",
    "damageMin": 28,
    "damageMax": 46,
    "speed": 4,
    "critChance": 0.02,
    "critPower": 20,
    "defense": 0,
    "knockback": 0,
    "level": 8,
    "obtain": "The Mines, or Skull Cavern.",
    "sellPrice": 400,
    "canEnchant": true
  },
  {
    "id": "2",
    "type": "sword",
    "name": "Dark Sword",
    "image": "images/weapons/swords/Dark Sword.png",
    "damageMin": 30,
    "damageMax": 45,
    "speed": -5,
    "critChance": 0.04,
    "critPower": 0,
    "defense": 0,
    "knockback": 5,
    "level": 9,
    "obtain": "Dropped by Haunted Skulls.",
    "sellPrice": 450,
    "canEnchant": true
  },
  {
    "id": "9",
    "type": "sword",
    "name": "Lava Katana",
    "image": "images/weapons/swords/Lava Katana.png",
    "damageMin": 55,
    "damageMax": 64,
    "speed": 0,
    "critChance": 0.015,
    "critPower": 25,
    "defense": 3,
    "knockback": 3,
    "level": 10,
    "obtain": "Purchased from the Adventurer's Guild for 25,000g after reaching The Mines floor 120.",
    "sellPrice": 500,
    "canEnchant": true
  },
  {
    "id": "57",
    "type": "sword",
    "name": "Dragontooth Cutlass",
    "image": "images/weapons/swords/Dragontooth Cutlass.png",
    "damageMin": 75,
    "damageMax": 90,
    "speed": 0,
    "critChance": 0.02,
    "critPower": 50,
    "defense": 0,
    "knockback": 0,
    "level": 13,
    "obtain": "Volcano Dungeon chest.",
    "sellPrice": 650,
    "canEnchant": true
  },
  {
    "id": "54",
    "type": "sword",
    "name": "Dwarf Sword",
    "image": "images/weapons/swords/Dwarf Sword.png",
    "damageMin": 65,
    "damageMax": 75,
    "speed": 2,
    "critChance": 0.02,
    "critPower": 0,
    "defense": 4,
    "knockback": 0,
    "level": 13,
    "obtain": "Volcano Dungeon chest.",
    "sellPrice": 650,
    "canEnchant": true
  },
  {
    "id": "4",
    "type": "sword",
    "name": "Galaxy Sword",
    "image": "images/weapons/swords/Galaxy Sword.png",
    "damageMin": 60,
    "damageMax": 80,
    "speed": 4,
    "critChance": 0.02,
    "critPower": 0,
    "defense": 0,
    "knockback": 0,
    "level": 13,
    "obtain": "Bring a Prismatic Shard to the Three Pillars in the Calico Desert.",
    "sellPrice": 650,
    "canEnchant": true
  },
  {
    "id": "62",
    "type": "sword",
    "name": "Infinity Blade",
    "image": "images/weapons/swords/Infinity Blade.png",
    "damageMin": 80,
    "damageMax": 100,
    "speed": 4,
    "critChance": 0.02,
    "critPower": 0,
    "defense": 2,
    "knockback": 0,
    "level": 17,
    "obtain": "Forge the Galaxy Sword with 3 Galaxy Souls and 60 Cinder Shards.",
    "sellPrice": 850,
    "canEnchant": true
  },
  {
    "id": "16",
    "type": "dagger",
    "name": "Carving Knife",
    "image": "images/weapons/daggers/Carving Knife.png",
    "damageMin": 1,
    "damageMax": 3,
    "speed": 0,
    "critChance": 0.04,
    "critPower": 0,
    "defense": 0,
    "knockback": 0,
    "level": 1,
    "obtain": "The Mines floors 1–19.",
    "sellPrice": 50,
    "canEnchant": true
  },
  {
    "id": "17",
    "type": "dagger",
    "name": "Iron Dirk",
    "image": "images/weapons/daggers/Iron Dirk.png",
    "damageMin": 2,
    "damageMax": 4,
    "speed": 0,
    "critChance": 0.03,
    "critPower": 0,
    "defense": 0,
    "knockback": 0,
    "level": 1,
    "obtain": "The Mines, or purchased from the Adventurer's Guild.",
    "sellPrice": 50,
    "canEnchant": true
  },
  {
    "id": "22",
    "type": "dagger",
    "name": "Wind Spire",
    "image": "images/weapons/daggers/Wind Spire.png",
    "damageMin": 1,
    "damageMax": 5,
    "speed": 0,
    "critChance": 0.02,
    "critPower": 10,
    "defense": 0,
    "knockback": 5,
    "level": 1,
    "obtain": "The Mines floors 21–39.",
    "sellPrice": 50,
    "canEnchant": true
  },
  {
    "id": "20",
    "type": "dagger",
    "name": "Elf Blade",
    "image": "images/weapons/daggers/Elf Blade.png",
    "damageMin": 3,
    "damageMax": 5,
    "speed": 0,
    "critChance": 0.04,
    "critPower": 0,
    "defense": 0,
    "knockback": 0,
    "level": 2,
    "obtain": "The Mines, or purchased from the Adventurer's Guild.",
    "sellPrice": 100,
    "canEnchant": true
  },
  {
    "id": "18",
    "type": "dagger",
    "name": "Burglar's Shank",
    "image": "images/weapons/daggers/Burglar's Shank.png",
    "damageMin": 7,
    "damageMax": 12,
    "speed": 0,
    "critChance": 0.04,
    "critPower": 25,
    "defense": 0,
    "knockback": 0,
    "level": 4,
    "obtain": "The Mines, or Skull Cavern.",
    "sellPrice": 200,
    "canEnchant": true
  },
  {
    "id": "21",
    "type": "dagger",
    "name": "Crystal Dagger",
    "image": "images/weapons/daggers/Crystal Dagger.png",
    "damageMin": 4,
    "damageMax": 10,
    "speed": 0,
    "critChance": 0.03,
    "critPower": 50,
    "defense": 0,
    "knockback": 5,
    "level": 4,
    "obtain": "The Mines floor 60.",
    "sellPrice": 200,
    "canEnchant": true
  },
  {
    "id": "19",
    "type": "dagger",
    "name": "Shadow Dagger",
    "image": "images/weapons/daggers/Shadow Dagger.png",
    "damageMin": 10,
    "damageMax": 20,
    "speed": 0,
    "critChance": 0.04,
    "critPower": 0,
    "defense": 0,
    "knockback": 0,
    "level": 4,
    "obtain": "The Mines floors 61–79 and 101–119.",
    "sellPrice": 200,
    "canEnchant": true
  },
  {
    "id": "51",
    "type": "dagger",
    "name": "Broken Trident",
    "image": "images/weapons/daggers/Broken Trident.png",
    "damageMin": 15,
    "damageMax": 26,
    "speed": 0,
    "critChance": 0.02,
    "critPower": 0,
    "defense": 0,
    "knockback": 0,
    "level": 5,
    "obtain": "Fishing Treasure Chests.",
    "sellPrice": 250,
    "canEnchant": true
  },
  {
    "id": "45",
    "type": "dagger",
    "name": "Wicked Kris",
    "image": "images/weapons/daggers/Wicked Kris.png",
    "damageMin": 24,
    "damageMax": 30,
    "speed": 0,
    "critChance": 0.06,
    "critPower": 0,
    "defense": 0,
    "knockback": 0,
    "level": 8,
    "obtain": "The Mines, or Skull Cavern.",
    "sellPrice": 400,
    "canEnchant": true
  },
  {
    "id": "40",
    "type": "dagger",
    "name": "Abby's Planchette",
    "image": "images/weapons/daggers/Abby's Planchette.png",
    "damageMin": 24,
    "damageMax": 30,
    "speed": 0,
    "critChance": 0.06,
    "critPower": 0,
    "defense": 0,
    "knockback": 0,
    "level": 8,
    "obtain": "Abigail's stall at the Desert Festival.",
    "sellPrice": 200,
    "canEnchant": true
  },
  {
    "id": "35",
    "type": "dagger",
    "name": "Elliott's Pencil",
    "image": "images/weapons/daggers/Elliott's Pencil.png",
    "damageMin": 24,
    "damageMax": 30,
    "speed": 0,
    "critChance": 0.06,
    "critPower": 0,
    "defense": 0,
    "knockback": 0,
    "level": 8,
    "obtain": "Elliott's stall at the Desert Festival.",
    "sellPrice": 200,
    "canEnchant": true
  },
  {
    "id": "23",
    "type": "dagger",
    "name": "Galaxy Dagger",
    "image": "images/weapons/daggers/Galaxy Dagger.png",
    "damageMin": 30,
    "damageMax": 40,
    "speed": 1,
    "critChance": 0.02,
    "critPower": 0,
    "defense": 0,
    "knockback": 5,
    "level": 8,
    "obtain": "Purchased from the Adventurer's Guild for 35,000g after obtaining the Galaxy Sword.",
    "sellPrice": 400,
    "canEnchant": true
  },
  {
    "id": "56",
    "type": "dagger",
    "name": "Dwarf Dagger",
    "image": "images/weapons/daggers/Dwarf Dagger.png",
    "damageMin": 32,
    "damageMax": 38,
    "speed": 1,
    "critChance": 0.03,
    "critPower": 0,
    "defense": 6,
    "knockback": 5,
    "level": 11,
    "obtain": "Volcano Dungeon chest.",
    "sellPrice": 550,
    "canEnchant": true
  },
  {
    "id": "59",
    "type": "dagger",
    "name": "Dragontooth Shiv",
    "image": "images/weapons/daggers/Dragontooth Shiv.png",
    "damageMin": 40,
    "damageMax": 50,
    "speed": 0,
    "critChance": 0.05,
    "critPower": 100,
    "defense": 0,
    "knockback": 5,
    "level": 12,
    "obtain": "Volcano Dungeon chest.",
    "sellPrice": 600,
    "canEnchant": true
  },
  {
    "id": "61",
    "type": "dagger",
    "name": "Iridium Needle",
    "image": "images/weapons/daggers/Iridium Needle.png",
    "damageMin": 20,
    "damageMax": 35,
    "speed": 0,
    "critChance": 0.1,
    "critPower": 200,
    "defense": 0,
    "knockback": 0,
    "level": 12,
    "obtain": "14% chance drop from special slimes when the Shrine of Challenge is active.",
    "sellPrice": 600,
    "canEnchant": true
  },
  {
    "id": "64",
    "type": "dagger",
    "name": "Infinity Dagger",
    "image": "images/weapons/daggers/Infinity Dagger.png",
    "damageMin": 50,
    "damageMax": 70,
    "speed": 1,
    "critChance": 0.06,
    "critPower": 0,
    "defense": 3,
    "knockback": 5,
    "level": 16,
    "obtain": "Forge the Galaxy Dagger with 3 Galaxy Souls and 60 Cinder Shards.",
    "sellPrice": 800,
    "canEnchant": true
  },
  {
    "id": "31",
    "type": "club",
    "name": "Femur",
    "image": "images/weapons/clubs/Femur.png",
    "damageMin": 6,
    "damageMax": 11,
    "speed": 2,
    "critChance": 0.02,
    "critPower": 0,
    "defense": 0,
    "knockback": 0,
    "level": 2,
    "obtain": "The Mines, or purchased from the Adventurer's Guild.",
    "sellPrice": 100,
    "canEnchant": true
  },
  {
    "id": "24",
    "type": "club",
    "name": "Wood Club",
    "image": "images/weapons/clubs/Wood Club.png",
    "damageMin": 9,
    "damageMax": 16,
    "speed": 0,
    "critChance": 0.02,
    "critPower": 0,
    "defense": 0,
    "knockback": 0,
    "level": 2,
    "obtain": "The Mines floors 1–39.",
    "sellPrice": 100,
    "canEnchant": true
  },
  {
    "id": "27",
    "type": "club",
    "name": "Wood Mallet",
    "image": "images/weapons/clubs/Wood Mallet.png",
    "damageMin": 15,
    "damageMax": 24,
    "speed": 2,
    "critChance": 0.02,
    "critPower": 0,
    "defense": 0,
    "knockback": 2,
    "level": 3,
    "obtain": "The Mines, or purchased from the Adventurer's Guild.",
    "sellPrice": 150,
    "canEnchant": true
  },
  {
    "id": "26",
    "type": "club",
    "name": "Lead Rod",
    "image": "images/weapons/clubs/Lead Rod.png",
    "damageMin": 18,
    "damageMax": 27,
    "speed": -4,
    "critChance": 0.02,
    "critPower": 0,
    "defense": 0,
    "knockback": 0,
    "level": 4,
    "obtain": "The Mines floors 41–79.",
    "sellPrice": 200,
    "canEnchant": true
  },
  {
    "id": "46",
    "type": "club",
    "name": "Kudgel",
    "image": "images/weapons/clubs/Kudgel.png",
    "damageMin": 27,
    "damageMax": 40,
    "speed": -1,
    "critChance": 0.02,
    "critPower": 50,
    "defense": 0,
    "knockback": 2,
    "level": 5,
    "obtain": "The Mines floors 101+.",
    "sellPrice": 250,
    "canEnchant": true
  },
  {
    "id": "25",
    "type": "club",
    "name": "Alex's Bat",
    "image": "images/weapons/clubs/Alex's Bat.png",
    "damageMin": 40,
    "damageMax": 55,
    "speed": -2,
    "critChance": 0.02,
    "critPower": 0,
    "defense": 0,
    "knockback": 0,
    "level": 7,
    "obtain": "Alex's stall at the Desert Festival.",
    "sellPrice": 350,
    "canEnchant": true
  },
  {
    "id": "37",
    "type": "club",
    "name": "Harvey's Mallet",
    "image": "images/weapons/clubs/Harvey's Mallet.png",
    "damageMin": 40,
    "damageMax": 55,
    "speed": -2,
    "critChance": 0.02,
    "critPower": 0,
    "defense": 0,
    "knockback": 0,
    "level": 7,
    "obtain": "Harvey's stall at the Desert Festival.",
    "sellPrice": 350,
    "canEnchant": true
  },
  {
    "id": "36",
    "type": "club",
    "name": "Maru's Wrench",
    "image": "images/weapons/clubs/Maru's Wrench.png",
    "damageMin": 40,
    "damageMax": 55,
    "speed": -2,
    "critChance": 0.02,
    "critPower": 0,
    "defense": 0,
    "knockback": 0,
    "level": 7,
    "obtain": "Maru's stall at the Desert Festival.",
    "sellPrice": 350,
    "canEnchant": true
  },
  {
    "id": "38",
    "type": "club",
    "name": "Penny's Fryer",
    "image": "images/weapons/clubs/Penny's Fryer.png",
    "damageMin": 40,
    "damageMax": 55,
    "speed": -2,
    "critChance": 0.02,
    "critPower": 0,
    "defense": 0,
    "knockback": 0,
    "level": 7,
    "obtain": "Penny's stall at the Desert Festival.",
    "sellPrice": 350,
    "canEnchant": true
  },
  {
    "id": "30",
    "type": "club",
    "name": "Sam's Old Guitar",
    "image": "images/weapons/clubs/Sam's Old Guitar.png",
    "damageMin": 40,
    "damageMax": 55,
    "speed": -2,
    "critChance": 0.02,
    "critPower": 0,
    "defense": 0,
    "knockback": 0,
    "level": 7,
    "obtain": "Sam's stall at the Desert Festival.",
    "sellPrice": 350,
    "canEnchant": true
  },
  {
    "id": "41",
    "type": "club",
    "name": "Seb's Lost Mace",
    "image": "images/weapons/clubs/Seb's Lost Mace.png",
    "damageMin": 40,
    "damageMax": 55,
    "speed": -2,
    "critChance": 0.02,
    "critPower": 0,
    "defense": 0,
    "knockback": 0,
    "level": 7,
    "obtain": "Sebastian's stall at the Desert Festival.",
    "sellPrice": 350,
    "canEnchant": true
  },
  {
    "id": "28",
    "type": "club",
    "name": "The Slammer",
    "image": "images/weapons/clubs/The Slammer.png",
    "damageMin": 40,
    "damageMax": 55,
    "speed": -2,
    "critChance": 0.02,
    "critPower": 0,
    "defense": 0,
    "knockback": 0,
    "level": 7,
    "obtain": "The Mines floors 81–99, or Skull Cavern.",
    "sellPrice": 350,
    "canEnchant": true
  },
  {
    "id": "29",
    "type": "club",
    "name": "Galaxy Hammer",
    "image": "images/weapons/clubs/Galaxy Hammer.png",
    "damageMin": 70,
    "damageMax": 90,
    "speed": 2,
    "critChance": 0.02,
    "critPower": 0,
    "defense": 0,
    "knockback": 5,
    "level": 12,
    "obtain": "Purchased from the Adventurer's Guild for 75,000g after obtaining the Galaxy Sword.",
    "sellPrice": 600,
    "canEnchant": true
  },
  {
    "id": "55",
    "type": "club",
    "name": "Dwarf Hammer",
    "image": "images/weapons/clubs/Dwarf Hammer.png",
    "damageMin": 75,
    "damageMax": 85,
    "speed": 0,
    "critChance": 0.02,
    "critPower": 0,
    "defense": 2,
    "knockback": 5,
    "level": 13,
    "obtain": "Volcano Dungeon chest.",
    "sellPrice": 650,
    "canEnchant": true
  },
  {
    "id": "58",
    "type": "club",
    "name": "Dragontooth Club",
    "image": "images/weapons/clubs/Dragontooth Club.png",
    "damageMin": 80,
    "damageMax": 100,
    "speed": 0,
    "critChance": 0.02,
    "critPower": 50,
    "defense": 0,
    "knockback": 3,
    "level": 14,
    "obtain": "Volcano Dungeon chest.",
    "sellPrice": 700,
    "canEnchant": true
  },
  {
    "id": "63",
    "type": "club",
    "name": "Infinity Gavel",
    "image": "images/weapons/clubs/Infinity Gavel.png",
    "damageMin": 100,
    "damageMax": 120,
    "speed": 2,
    "critChance": 0.02,
    "critPower": 0,
    "defense": 1,
    "knockback": 5,
    "level": 17,
    "obtain": "Forge the Galaxy Hammer with 3 Galaxy Souls and 60 Cinder Shards.",
    "sellPrice": 850,
    "canEnchant": true
  },
  {
    "id": "32",
    "type": "slingshot",
    "name": "Slingshot",
    "image": "images/weapons/slingshots/Slingshot.png",
    "obtain": "The Mines floor 40 chest.",
    "sellPrice": 50,
    "canEnchant": true
  },
  {
    "id": "33",
    "type": "slingshot",
    "name": "Master Slingshot",
    "image": "images/weapons/slingshots/Master Slingshot.png",
    "obtain": "The Mines floor 70 chest.",
    "sellPrice": 50,
    "canEnchant": true
  }
]
